document.addEventListener("DOMContentLoaded", () => {
  const productGrid = document.querySelector(".completeHomeProductGrid");
  const areas = document.querySelectorAll('[data-filter-group="area"] .filter-tile');
  const brandSelect = document.querySelector('[data-filter-type="brand"]');

  let activeArea = null;
  let activeBrand = null;

  // AREA CLICK → fetch results with ?area=<tag>
  areas.forEach(tile => {
    tile.addEventListener("click", () => {
      areas.forEach(t => t.classList.remove("active"));
      tile.classList.add("active");

      activeArea = tile.dataset.filterValue; // e.g. dine/sleep/bathe/clean
      if (!activeArea) return;

      const url = new URL(window.location.href);
      const basePath = url.pathname.split("?")[0];

      const params = new URLSearchParams();
      params.set("section_id", "ops-palettes-results");
      params.set("area", activeArea);
      if (activeBrand) params.set("filter.p.m.custom.brand", activeBrand);

      const targetUrl = `${basePath}?${params.toString()}`;

      if (productGrid) productGrid.classList.add("is-loading");

      fetch(targetUrl)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const newGrid = doc.querySelector(".completeHomeProductGrid");
          if (newGrid && productGrid) productGrid.innerHTML = newGrid.innerHTML;
        })
        .finally(() => {
          if (productGrid) {
            productGrid.classList.remove("is-loading");
            productGrid.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
    });
  });

  // BRAND CHANGE → preserve ?area if present
  if (brandSelect && productGrid) {
    brandSelect.addEventListener("change", e => {
      activeBrand = e.target.value || null;

      const url = new URL(window.location.href);
      const basePath = url.pathname.split("?")[0];

      // keep area from current URL if present
      const currentArea = (new URLSearchParams(url.search)).get("area");
      const params = new URLSearchParams();
      params.set("section_id", "ops-palettes-results");
      if (currentArea) params.set("area", currentArea);
      if (activeBrand) params.set("filter.p.m.custom.brand", activeBrand);

      const targetUrl = `${basePath}?${params.toString()}`;

      productGrid.classList.add("is-loading");
      fetch(targetUrl)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const newGrid = doc.querySelector(".completeHomeProductGrid");
          if (newGrid) productGrid.innerHTML = newGrid.innerHTML;
        })
        .finally(() => {
          productGrid.classList.remove("is-loading");
          productGrid.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    });
  }
});
